import Vue from 'vue'

import EApp from 'elia.design/component/EApp.vue'

import EAppBar from 'elia.design/component/EAppBar.vue'
import EAppBarNavIcon from 'elia.design/component/EAppBarNavIcon.vue'
import ENavigationToggler from 'elia.design/component/ENavigationToggler.vue'
import ENavigationDrawer from 'elia.design/component/ENavigationDrawer.vue'
import EBottomNavigation from 'elia.design/component/EBottomNavigation.vue'

import EContainer from 'elia.design/component/EContainer.vue'

import EBtn from 'elia.design/component/EBtn.vue'
import EBtnIcon from 'elia.design/component/EBtnIcon.vue'
import EIcon from 'elia.design/component/EIcon.vue'
import EImg from 'elia.design/component/EImg.vue'

import ESheet from 'elia.design/component/ESheet.vue'
import EBanner from 'elia.design/component/EBanner.vue'
import ESpacer from 'elia.design/component/ESpacer.vue'
import ESubheader from 'elia.design/component/ESubheader.vue'

import EList from 'elia.design/component/EList.vue'
import EListItem from 'elia.design/component/EListItem.vue'
import EListItemGroup from 'elia.design/component/EListItemGroup.vue'
import EListItemAction from 'elia.design/component/EListItemAction.vue'
import EListItemAvatar from 'elia.design/component/EListItemAvatar.vue'
import EListItemIcon from 'elia.design/component/EListItemIcon.vue'
import EListItemTitle from 'elia.design/component/EListItemTitle.vue'
import EListItemSubtitle from 'elia.design/component/EListItemSubtitle.vue'
import EListItemContent from 'elia.design/component/EListItemContent.vue'

import EChip from 'elia.design/component/EChip.vue'
import EAlert from 'elia.design/component/EAlert.vue'

import EBtnToggle from 'elia.design/component/EBtnToggle.vue'

import ECard from 'elia.design/component/ECard.vue'
import ECardTitle from 'elia.design/component/ECardTitle.vue'
import ECardText from 'elia.design/component/ECardText.vue'
import ECardActions from 'elia.design/component/ECardActions.vue'

import ETooltip from 'elia.design/component/ETooltip.vue'
import EToolbar from 'elia.design/component/EToolbar.vue'
import EToolbarTitle from 'elia.design/component/EToolbarTitle.vue'

import ESnackbar from 'elia.design/component/ESnackbar.vue'
import EDialog from 'elia.design/component/EDialog.vue'

import EMenu from 'elia.design/component/EMenu.vue'
import EDatePicker from 'elia.design/component/EDatePicker.vue'
import EForm from 'elia.design/component/EForm.vue'
import ELabel from 'elia.design/component/ELabel.vue'
import EInput from 'elia.design/component/EInput.vue'
import EMessages from 'elia.design/component/EMessages.vue'
import ESelect from 'elia.design/component/ESelect.vue'
import ETextField from 'elia.design/component/ETextField.vue'
import ESwitch from 'elia.design/component/ESwitch.vue'
import ECheckbox from 'elia.design/component/ECheckbox.vue'

import EStepper from 'elia.design/component/EStepper.vue'
import EStepperContent from 'elia.design/component/EStepperContent.vue'
import EStepperHeader from 'elia.design/component/EStepperHeader.vue'
import EStepperItems from 'elia.design/component/EStepperItems.vue'
import EStepperStep from 'elia.design/component/EStepperStep.vue'

import EDivider from 'elia.design/component/EDivider.vue'

import EProgressCircular from 'elia.design/component/EProgressCircular.vue'
import ERow from 'elia.design/component/ERow.vue'
import ECol from 'elia.design/component/ECol.vue'

import EExpansionPanels from 'elia.design/component/EExpansionPanels.vue'
import EExpansionPanel from 'elia.design/component/EExpansionPanel.vue'
import EExpansionPanelHeader from 'elia.design/component/EExpansionPanelHeader.vue'
import EExpansionPanelContent from 'elia.design/component/EExpansionPanelContent.vue'

// FOR IDE INSPECTION

Vue.component('e-app', EApp)
Vue.component('e-app-bar', EAppBar)
Vue.component('e-app-bar-nav-icon', EAppBarNavIcon)
Vue.component('e-navigation-toggler', ENavigationToggler)
Vue.component('e-navigation-drawer', ENavigationDrawer)
Vue.component('e-bottom-navigation', EBottomNavigation)

Vue.component('e-container', EContainer)

Vue.component('e-btn', EBtn)
Vue.component('e-btn-icon', EBtnIcon)
Vue.component('e-icon', EIcon)
Vue.component('e-img', EImg)

Vue.component('e-sheet', ESheet)
Vue.component('e-banner', EBanner)
Vue.component('e-spacer', ESpacer)
Vue.component('e-subheader', ESubheader)

Vue.component('e-list', EList)
Vue.component('e-list-item-group', EListItemGroup)
Vue.component('e-list-item', EListItem)
Vue.component('e-list-item-action', EListItemAction)
Vue.component('e-list-item-avatar', EListItemAvatar)
Vue.component('e-list-item-icon', EListItemIcon)
Vue.component('e-list-item-title', EListItemTitle)
Vue.component('e-list-item-subtitle', EListItemSubtitle)
Vue.component('e-list-item-content', EListItemContent)

Vue.component('e-chip', EChip)
Vue.component('e-alert', EAlert)

Vue.component('e-btn-toggle', EBtnToggle)

Vue.component('e-card', ECard)
Vue.component('e-card-title', ECardTitle)
Vue.component('e-card-text', ECardText)
Vue.component('e-card-actions', ECardActions)

Vue.component('e-tooltip', ETooltip)
Vue.component('e-toolbar', EToolbar)
Vue.component('e-toolbar-title', EToolbarTitle)

Vue.component('e-snackbar', ESnackbar)
Vue.component('e-dialog', EDialog)

Vue.component('e-menu', EMenu)
Vue.component('e-date-picker', EDatePicker)
Vue.component('e-form', EForm)
Vue.component('e-select', ESelect)
Vue.component('e-text-field', ETextField)
Vue.component('e-label', ELabel)
Vue.component('e-input', EInput)
Vue.component('e-messages', EMessages)
Vue.component('e-switch', ESwitch)
Vue.component('e-checkbox', ECheckbox)

Vue.component('e-stepper', EStepper)
Vue.component('e-stepper-content', EStepperContent)
Vue.component('e-stepper-header', EStepperHeader)
Vue.component('e-stepper-items', EStepperItems)
Vue.component('e-stepper-step', EStepperStep)

Vue.component('e-divider', EDivider)

Vue.component('e-progress-circular', EProgressCircular)
Vue.component('e-row', ERow)
Vue.component('e-col', ECol)

Vue.component('e-expansion-panels', EExpansionPanels)
Vue.component('e-expansion-panel', EExpansionPanel)
Vue.component('e-expansion-panel-header', EExpansionPanelHeader)
Vue.component('e-expansion-panel-content', EExpansionPanelContent)
